// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1lQ1k","rootSuccess":"CompleteLink_rootSuccess__GIMJz","rootFailure":"CompleteLink_rootFailure__1oFBY","isDisabled":"CompleteLink_isDisabled__3mllP"};